module.exports = __webpack_public_path__ + "img/course_bg1.0a9900e6.png";